export const TranslationStorageConst = {
  keys: {
    lang: 'lang'
  }
};
